module.exports = __webpack_public_path__ + "static/Taramosalata-38193a45f2b041e4826df0a9516152f7.png";